import React from 'react';
import PropTypes from 'prop-types';

import { useWizard } from '../Wizard/WizardContext';

import StyledStepper, {
  Step,
  Bullet,
  Title,
  CheckMark,
} from './Stepper.styles';

const Stepper = ({ onStepClick, ...rest }) => {
  const { activeStep, totalSteps, stepsTitle } = useWizard();

  return (
    <StyledStepper
      role='progressbar'
      tabIndex='0'
      aria-valuemin='1'
      aria-valuenow={activeStep + 1}
      aria-valuemax={totalSteps}
      {...rest}
    >
      {[...Array(totalSteps)].map((_, index) => (
        <Step
          key={String(index + 1)}
          active={index === activeStep}
          done={index < activeStep}
        >
          <Bullet
            onClick={(e) => {
              e.preventDefault();
              onStepClick(index);
            }}
            disabled={index >= activeStep}
          >
            <Title>{stepsTitle[index]}</Title>

            <CheckMark />
          </Bullet>
        </Step>
      ))}
    </StyledStepper>
  );
};

Stepper.propTypes = {
  onStepClick: PropTypes.func,
};

Stepper.defaultProps = {
  onStepClick: () => {},
};

export default Stepper;
